import React from 'react'
import PropTypes from 'prop-types'
import { sizes } from '@qflow/theme'

export function DesignMatch({
  colour = 'currentColor',
  size = sizes.MEDIUM,
  ...props
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="31"
      height="36"
      viewBox="0 0 31 36"
      {...props}
      style={{
        height: size,
        width: `calc(${size} * (31 / 36))`,
        verticalAlign: 'middle'
      }}
    >
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M22.1786 9.48214V7.55357C22.1786 7.37679 22.0339 7.23214 21.8571 7.23214H6.42857C6.25179 7.23214 6.10714 7.37679 6.10714 7.55357V9.48214C6.10714 9.65893 6.25179 9.80357 6.42857 9.80357H21.8571C22.0339 9.80357 22.1786 9.65893 22.1786 9.48214ZM6.42857 13.0179C6.25179 13.0179 6.10714 13.1625 6.10714 13.3393V15.2679C6.10714 15.4446 6.25179 15.5893 6.42857 15.5893H13.8214C13.9982 15.5893 14.1429 15.4446 14.1429 15.2679V13.3393C14.1429 13.1625 13.9982 13.0179 13.8214 13.0179H6.42857ZM12.2143 31.1786H2.89286V2.89286H25.3929V16.7143C25.3929 16.8911 25.5375 17.0357 25.7143 17.0357H27.9643C28.1411 17.0357 28.2857 16.8911 28.2857 16.7143V1.28571C28.2857 0.574554 27.7112 0 27 0H1.28571C0.574554 0 0 0.574554 0 1.28571V32.7857C0 33.4969 0.574554 34.0714 1.28571 34.0714H12.2143C12.3911 34.0714 12.5357 33.9268 12.5357 33.75V31.5C12.5357 31.3232 12.3911 31.1786 12.2143 31.1786ZM30.1219 33.2478L26.3732 29.4991C27.2692 28.3138 27.8036 26.8353 27.8036 25.2321C27.8036 21.3268 24.6375 18.1607 20.7321 18.1607C16.8268 18.1607 13.6607 21.3268 13.6607 25.2321C13.6607 29.1375 16.8268 32.3036 20.7321 32.3036C22.1705 32.3036 23.5045 31.8737 24.6214 31.1384L28.4263 34.9433C28.4906 35.0076 28.571 35.0357 28.6513 35.0357C28.7317 35.0357 28.8161 35.0036 28.8763 34.9433L30.1219 33.6978C30.1515 33.6683 30.175 33.6332 30.1911 33.5946C30.2071 33.556 30.2154 33.5146 30.2154 33.4728C30.2154 33.431 30.2071 33.3896 30.1911 33.3509C30.175 33.3123 30.1515 33.2773 30.1219 33.2478V33.2478ZM20.7321 29.7321C18.2451 29.7321 16.2321 27.7192 16.2321 25.2321C16.2321 22.7451 18.2451 20.7321 20.7321 20.7321C23.2192 20.7321 25.2321 22.7451 25.2321 25.2321C25.2321 27.7192 23.2192 29.7321 20.7321 29.7321Z"
        fill={colour}
      />
    </svg>
  )
}

DesignMatch.propTypes = {
  colour: PropTypes.string,
  size: PropTypes.string
}
